export default "__VITE_ASSET__heP8Ssu6GxUO_ZIYYhGEAQ__"